import React from 'react';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';

const revertApplicationConfirmation = (
  isLoading,
  transactionStatus,
  applicationStatus,
  transactionType,  
  onYesCallBack,
  onNoCallback = () => {}
) => {
  const isStatusAllowed = 
    (['VERIFIED', 'ASSESSED BY PLANNING DEPARTMENT', 'ASSESSED BY ENGINEERING DEPARTMENT', 'FOR ACCOUNT CREATION'].indexOf(transactionStatus) > -1 && transactionType === 'new') ||
    (['VERIFIED'].indexOf(transactionStatus) > -1 && transactionType === 'renewal');

  const isApplicationStatusAllowed =
    (['VERIFIED', 'ASSESSED BY PLANNING DEPARTMENT', 'ASSESSED BY ENGINEERING DEPARTMENT', 'FOR ACCOUNT CREATION'].indexOf(applicationStatus) > -1 && transactionType === 'new') ||
    (['VERIFIED'].indexOf(applicationStatus) > -1 && transactionType === 'renewal');
    
  const isAllowed = isStatusAllowed;

  const showComponent =
    isAllowed &&
    isApplicationStatusAllowed;

  const onHandleClick = e => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want revert this application?`,
      onYesCallBack,
      onNoCallback,
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const component = showComponent ? (
    <div className="mx-2 mb-2">
      <button
        disabled={isLoading}
        onClick={onHandleClick}
        type="button"
        className="btn btn-black text-white font-weight-bold   "
      >
        {isLoading && (
          <>
            <i className="fas fa-spinner fa-spin" />
            &nbsp;
          </>
        )}
        Revert Application
      </button>
    </div>
  ) : null;

  return {
    isAllowed,
    onHandleClick,
    component,
  };
};

export default revertApplicationConfirmation;
